import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}
export const GeneralSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const hasGeneral = symptoms.general?.status === 'yes'

  const hasFever = symptoms.general?.fever?.isSelected

  return (
    <>
      <Col span={24}>
        <Text>
          {`1. ${t('epidemiology.general')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${symptoms.general?.status}`)}
          </Text>
        </Text>
      </Col>

      {hasGeneral && (
        <>
          {hasFever && (
            <Col span={6}>
              <Text>
                {t('epidemiology.symptoms.general.fever')} -{' '}
                {symptoms.general?.fever?.temperature?.value}
              </Text>
            </Col>
          )}

          {symptoms.general?.frisoane?.isSelected && (
            <Col span={6}>
              <Text>{t('epidemiology.symptoms.general.frisoane')}</Text>
            </Col>
          )}

          {symptoms.general?.pronouncedWeakness?.isSelected && (
            <Col span={6}>
              <Text>
                {t('epidemiology.symptoms.general.pronouncedWeakness')}
              </Text>
            </Col>
          )}

          {symptoms.general?.seriousCondition?.isSelected && (
            <Col span={6}>
              <Text>{t('epidemiology.symptoms.general.seriousCondition')}</Text>
            </Col>
          )}

          {symptoms.general?.coma?.isSelected && (
            <Col span={6}>
              <Text>{t('epidemiology.symptoms.general.coma')}</Text>
            </Col>
          )}

          {symptoms.general?.persistentСrying?.isSelected && (
            <Col span={6}>
              <Text>{t('epidemiology.symptoms.general.persistentCrying')}</Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
